import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import { reducer as FormReducer } from 'redux-form';
// import logger from 'redux-logger';
import { persistCombineReducers, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import BatchReducer from '../components/users/reducer.BatchAction';
import { ENV } from '../enviroments';

import UsersReducer from './../components/users/reducer.Users';

/**
 *  REDUX-PERSIST CONFIGURATION
 */
const persistenceConfiguration = {
    key: 'primary',
    storage,
    blacklist: [
        'form',
        'permissionToAddForGroup',
        'permissionToAdd',
        'permissionToRemove',
        'fetchedAvailablePermissionForGroup',
        'fetchedAssignedPermissionsToGroup',
    ],
    whitelist: [],
};

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
});

const userReducer = combineReducers({
    userList: UsersReducer,
    batchAction: BatchReducer,
});

const rootReducer = combineReducers({
    users: userReducer,
    form: FormReducer,
});

const persistedReducers = persistCombineReducers(persistenceConfiguration, {
    router: routerReducer,
    persistedReducers: rootReducer,
});

/**
 * REDUX STORE CONFIGURATION
 */
const store = configureStore({
    reducer: persistedReducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).prepend(routerMiddleware),
    // .concat(logger),
    devTools: ENV === 'dev' || ENV === 'local',
});
//The store has been created with these options:
// - The slice reducers were automatically passed to combineReducers()
// - redux-thunk and redux-logger were added as middleware
// - The Redux DevTools Extension is enabled -> TODO: DISABLE IT ON PRODUCTION!!
// - The middleware, and devtools enhancers were composed together

const persistor = persistStore(store);

const history = createReduxHistory(store);

export { history, persistor };

export default store;
// Get the type of our store variable
export type AppStore = typeof store;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch'];
